export const SECONDS = 60;
export const MINUTES = 60 * 60;
export const DAY_IN_SECONDS = 60 * 60 * 24; // 86400
